var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablePopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 130,
    viewBox: "0 0 218 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 217,
    height: 129,
    rx: 3.5,
    stroke: "#D3D5DB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 217,
    height: 129,
    rx: 3.5,
    stroke: "#D3D5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26H218",
    stroke: "#D3D5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 52H218",
    stroke: "#D3D5DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 78H218",
    stroke: "#D3D5DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 104H218",
    stroke: "#D3D5DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.4 0L174.4 130",
    stroke: "#D3D5DB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.801 0L130.801 130",
    stroke: "#D3D5DB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1992 0L87.1992 130",
    stroke: "#D3D5DB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5996 0L43.5996 130",
    stroke: "#D3D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablePopup);
export default __webpack_public_path__ + "static/media/table-popup.aaedbc06e4bb3b515760b3bbe5812dd2.svg";
export { ForwardRef as ReactComponent };